<template>
  <b-modal
    :hide-footer="true"
    :title="`Relacionar com um ${text} existente`"
    centered
    size="lg"
    id="relacionar-model"
    :no-close-on-backdrop="true"
  >
    <div>
      <loading-animation
        :active.sync="loading"
        :is-full-page="false"
        :opacity="1"
        color="#5895FF"
      />

      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <div>
            <i class="mdi mdi-connection" />
            Localize o item e clique em relacionar
          </div>
          <div>
            <div class="input-group mb-3">
              <b-input
                :placeholder="$t('Type to search')"
                class="form-control search-input"
                type="text"
                v-model="search"
                v-on:change="getItens(familiaId)"
                aria-describedby="input-search"
              />
              <div class="input-group-append" role="button">
                <span class="input-group-text" id="input-search"
                  ><i class="fas fa-search search-icon"
                /></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <AtendimentoList
          v-if="table == 'atendimentos'"
          :itens.sync="itens"
          @reload="getItens(familiaId)"
          :relacionar="true"
          @relacionar="submit($event)"
        />
        <EncaminhamentoList
          v-else-if="table == 'encaminhamentos'"
          :itens.sync="itens"
          @reload="getItens(familiaId)"
          :relacionar="true"
          @relacionar="submit($event)"
        />
        <OficiosList
          v-else-if="table == 'oficios'"
          :itens.sync="itens"
          @reload="getItens()"
          :relacionar="true"
          @relacionar="submit($event)"
          :pagination="pagination"
          :porpagina="perPage"
          @paginar="changePage($event)"
          :page="page"
        />
      </div>
    </div>
  </b-modal>
</template>
<script>
import AtendimentoList from "./abas/lista/ListAtendimentos";
import EncaminhamentoList from "./abas/lista/ListEncaminhamentos";
import OficiosList from "./abas/lista/ListOficios";
export default {
  props: ["table", "text", "label", "itemId", "familiaId"],
  components: {
    AtendimentoList,
    EncaminhamentoList,
    OficiosList,
  },
  data() {
    return {
      search: "",
      itens: [],
      loading: false,
      perPage: 5,
      page: 1,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
    };
  },
  mounted() {
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      if (modalId == "relacionar-model") {
        this.getItens();
      }
    });
  },
  watch: {
    familiaId: function (value) {
      this.getItens();
    },
  },
  methods: {
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getItens();
      }
    },
    getItens() {
      this.loading = true;
      axios
        .post(`api/dashboard/vvd/get/itensModel`, {
          table: this.table,
          familia_id: this.familiaId,
          vvd_id: this.itemId,
          page: this.page,
          search: this.search,
          perPage: this.perPage,
        })
        .then((response) => {
          this.itens = response.data.data;
          this.pagination = response.data.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getItens();
          } else {
            this.loading = false;
          }

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    submit(id) {
      let ladda = Ladda.create(document.querySelector(".btn-relacionar-" + id));
      ladda.start();

      axios
        .post(`api/dashboard/vvd/relacionar`, {
          id: id,
          table: this.table,
          vvd_id: this.itemId,
        })
        .then((response) => {
          this.$emit("reload");
          this.$bvModal.hide("relacionar-model");
          ladda.stop();
        })
        .catch((e) => ladda.stop());
    },
  },
};
</script>
